<template>
  <div>
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="450px"
      transition="slide-y-transition"
    >
      <v-card class="dialog-card-border">
        <v-card-title class="text-h6 font-weight-light">
          {{ editMode ? $t('Update Item') : $t('Add New Item') }}
        </v-card-title>

        <validation-observer
          ref="theForm"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            autocomplete="off"
            @submit.prevent="handleSubmit(submit)"
            @reset.prevent="reset"
          >
            <v-card-text>
              <v-row no-gutters>
                <v-col
                  class="px-1"
                  cols="12"
                  lg="12"
                >
                  <app-branch-select v-model="formData.branch_id" />
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  lg="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Name')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="formData.name"
                      :label="`* ${$t('Name')}`"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>

                <v-col
                  class="px-1"
                  cols="12"
                  lg="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Code')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="formData.code"
                      :label="`* ${$t('Code')}`"
                      outlined
                      dense
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="py-3">
              <app-form-tip />

              <v-spacer />

              <v-btn
                depressed
                outlined
                small
                @click="closeDialog()"
              >
                {{ $t('Cancel') }}
              </v-btn>

              <app-submit-button :edit-mode="editMode" />
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    addEditDialog: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
    editMode: { type: Boolean, default: false },
  },

  methods: {
    closeDialog() {
      this.$refs.theForm.reset()
      this.$emit('close')
    },

    submit() {
      if (this.editMode) {
        axios.put(`item/${this.formData.id}/`, this.formData).then(() => {
          this.$_notify('Updated successfully')
          this.closeDialog()
          this.$emit('update-table-data')
        })
      } else {
        axios.post('item/', this.formData).then(res => {
          this.$_notify('Added successfully')
          this.closeDialog()
          this.$emit('reset-table-data', res.data)
        })
      }
    }
  },
}
</script>
<style lang="scss">
</style>